"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_commands_1 = require("prosemirror-commands");
var prosemirror_state_1 = require("prosemirror-state");
var prosemirror_keymap_1 = require("prosemirror-keymap");
var UxCommands = __importStar(require("./behavior"));
var prosemirror_history_1 = require("prosemirror-history");
var createKeyMapPlugin = function (bindings, key) {
    return new prosemirror_state_1.Plugin({ key: key, props: { handleKeyDown: prosemirror_keymap_1.keydownHandler(bindings) } });
};
// to prevent override basemap's basic map
var backspace = prosemirror_commands_1.chainCommands(UxCommands.deleteSelection, UxCommands.selectBefore, prosemirror_commands_1.joinBackward, prosemirror_commands_1.selectNodeBackward, UxCommands.clearFormatAtHead, UxCommands.deleteZeroChar);
var enter = prosemirror_commands_1.chainCommands(prosemirror_commands_1.newlineInCode, prosemirror_commands_1.createParagraphNear, prosemirror_commands_1.liftEmptyBlock, UxCommands.splitBlockKeepMarks);
var composeKeymap = function (keyMaps, mapping) {
    if (mapping === void 0) { mapping = {}; }
    return keyMaps.reduce(function (res, cur) {
        Object.keys(cur).forEach(function (key) {
            if (res[key]) {
                res[key] = prosemirror_commands_1.chainCommands(res[key], cur[key]);
            }
            else {
                res[key] = cur[key];
            }
        });
        return res;
    }, mapping);
};
exports.composeKeymap = composeKeymap;
var getCustomKeymapPlugins = function (customKeyMaps) {
    return createKeyMapPlugin(composeKeymap(customKeyMaps), new prosemirror_state_1.PluginKey('customKeymap'));
};
exports.getCustomKeymapPlugins = getCustomKeymapPlugins;
var getInnerKeymapPlugins = function () { return [
    createKeyMapPlugin({
        Enter: UxCommands.splitListItemKeepMarks,
        'Shift-Tab': UxCommands.liftListItem,
        Tab: UxCommands.sinkListItem,
        Backspace: UxCommands.liftListItemAtHead
    }, new prosemirror_state_1.PluginKey('listKeymap')),
    createKeyMapPlugin({
        Enter: enter,
        'Mod-z': UxCommands.undo,
        'Mod-y': prosemirror_history_1.redo,
        'Shift-Mod-z': prosemirror_history_1.redo,
        Backspace: backspace,
        'Alt-ArrowUp': prosemirror_commands_1.joinUp,
        'Alt-ArrowDown': prosemirror_commands_1.joinDown,
        'Mod-Bracketleft': prosemirror_commands_1.lift,
        Escape: prosemirror_commands_1.selectParentNode,
        'Shift-Enter': UxCommands.insertBreak
    }, new prosemirror_state_1.PluginKey('basicKeymap')),
    createKeyMapPlugin(prosemirror_commands_1.baseKeymap, new prosemirror_state_1.PluginKey('defaultKeymap'))
]; };
exports.getInnerKeymapPlugins = getInnerKeymapPlugins;
var getKeymapPlugins = function (customKeyMaps) { return __spreadArrays([
    getCustomKeymapPlugins(customKeyMaps)
], getInnerKeymapPlugins()); };
exports.getKeymapPlugins = getKeymapPlugins;
//# sourceMappingURL=keymap.js.map